import React, { Fragment, Suspense, lazy } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import arrMenu from "./../../constants/menuRoutes";
import config from "./../../common/config";
import app from "./../../common/app";
import core from "./../../common/core";
import Loader from "./../loader";
import TermsNCondition from "../more/tnc";
import UserBoostersHistory from "../../screens/userBoostersHistory";
import PrivacyPolicy from "../more/privacyPolicy";

// import Tnc from './../statictnc';

const Home = lazy(() =>
  import(/* webpackChunkName: 'home' */ "./../../screens/home")
);
const CreateTeam = lazy(() =>
  import(/* webpackChunkName: 'myTeam' */ "./../../screens/createTeam")
);
const contest = lazy(() =>
  import(/* webpackChunkName: 'myContest' */ "./../../screens/contest")
);
const TransferTeam = lazy(() =>
  import(
    /* webpackChunkName: 'myTeamTransfer' */ "./../../screens/transferTeam"
  )
);
const ViewTeam = lazy(() =>
  import(/* webpackChunkName: 'myTeamView' */ "./../../screens/viewTeam")
);
const Stats = lazy(() =>
  import(/* webpackChunkName: 'stats' */ "./../../screens/stats")
);

const PlayersStats = lazy(() =>
  import(/* webpackChunkName: 'stats' */ "./../playerStatisticsNew")
);
const NoMatch = lazy(() =>
  import(/* webpackChunkName: 'noMatch' */ "./../noMatch")
);
const Rules = lazy(() =>
  import(/* webpackChunkName: 'rules' */ "./../../screens/rules")
);
const More = lazy(() =>
  import(/* webpackChunkName: 'more' */ "./../../screens/more")
);
const Prizes = lazy(() =>
  import(/* webpackChunkName: 'prizes' */ "./../../screens/prizes")
);
const Badges = lazy(() =>
  import(/* webpackChunkName: 'badges' */ "./../../screens/badges")
);

const Form = lazy(() =>
  import(/* webpackChunkName: 'form' */ "./../../screens/form")
);

const UserTransfersHistory = lazy(() =>
  import(
    /* webpackChunkName: 'userTransferHistory' */ "./../../screens/userTransferHistory"
  )
);

const UserBoosterHistory = lazy(() =>
  import(
    /* webpackChunkName: 'userBoosterHistory' */ "./../../screens/userBoostersHistory"
  )
);

const UserPointsHistory = lazy(() =>
  import(
    /* webpackChunkName: 'userPointHistory' */ "./../../screens/userPointsHistory"
  )
);

// const GDPR = lazy(() => import(/* webpackChunkName: 'gdpr' */ "./../gdpr"));

let location = window.location.href;
let ObjRoute = {};
ObjRoute[config.enumStaticUrls.home] = Home;
ObjRoute[config.enumStaticUrls.createTeam] = CreateTeam;
ObjRoute[config.enumStaticUrls.contest] = contest;
ObjRoute[config.enumStaticUrls.transferTeam] = TransferTeam;
ObjRoute[config.enumStaticUrls.viewTeam] = ViewTeam;
ObjRoute[config.enumStaticUrls.stats] = PlayersStats;
ObjRoute[config.enumStaticUrls.rules] = Rules;
ObjRoute[config.enumStaticUrls.more] = More;
ObjRoute[config.enumStaticUrls.prizes] = Prizes;
ObjRoute[config.enumStaticUrls.badges] = Badges;
ObjRoute[config.enumStaticUrls.form] = Form;
ObjRoute[config.enumStaticUrls.transfersHistory] = UserTransfersHistory;
ObjRoute[config.enumStaticUrls.boostersHistory] = UserBoosterHistory;
ObjRoute[config.enumStaticUrls.pointsHistory] = UserPointsHistory;

// ObjRoute[config.enumStaticUrls.terms] = Tnc;
// ObjRoute[config.enumStaticUrls.faq] = FAQ;
// ObjRoute[config.enumStaticUrls.contact] = Contact;

const doDefaultNavigation = (props) => {
  const path = props.sPath;
  const routeObject = props.routeObject;
  const DefaultComponent = props.DefaultComponent;
  const trans = props.trans;
  const userEotStatus = props.userEotStatus;
  const cookie = app.getLoginCookie();
  let isAuthorize = routeObject.validator
    ? routeObject.validator(routeObject, cookie, userEotStatus)
    : true;
  let sTitle = "";

  document.title =
    trans && trans[routeObject.titleTransKey]
      ? trans[routeObject.titleTransKey]
      : routeObject.titleTransKey;

  if (!isAuthorize) {
    let shouldRedirectToLogin = isDeepLinkInLogout(props.location);
    if (shouldRedirectToLogin) {
      // redirect to login link with join league share link in cbUrl
      let lgUrl = config.redirectLogin.replace(
        "{{replace}}",
        `${props.location.pathname}`
      );
      window.location.href = lgUrl;
    } else {
      const sRedirect = config.redirectDefault.replace(
        "{{lang}}",
        config.CURRENT_LANGUAGE
      );
      return <Redirect to={sRedirect} />;
    }
  }

  sTitle = document.title;
  config.CURRENT_PATH = props.location ? props.location.pathname : path;
  let CompReturn = null;
  if (!CompReturn) {
    CompReturn = <DefaultComponent {...props} />;
  }
  const fResp = app.googleAnalyticsTracking(
    sTitle,
    /* config.URL_BASE + */ (
      config.CURRENT_PATH + window.location.search
    ).toLowerCase()
  );
  if (fResp) {
    let ObjEventParam = {
      page_title:
        trans && trans.myContestTabTitle
          ? trans.myContestTabTitle
          : "WWC Season Long 2025 Powered by My11Circle",
      page: routeObject.path,
      source: (config.CURRENT_PATH + window.location.search).toLowerCase(),
    };
    // app.d11DataTracking("PageLoaded", ObjEventParam);
  }
  // console.log('QueryStrings = ' + window.location.search);
  // console.log('Cookie = ' + document.cookie);
  //console.log((config.URL_BASE + config.CURRENT_PATH + window.location.search).toLowerCase());
  return CompReturn;
};

const isDeepLinkInLogout = (location) => {
  // check when deeplinking is active but user is loggedout
  let deepLinkUrl = config.URL_BASE + config.enumStaticUrls.contest + "/join/";
  if (
    location &&
    location.pathname &&
    location.pathname.indexOf(deepLinkUrl) > -1
  ) {
    let pathParts = location.pathname.split(deepLinkUrl);
    if (pathParts && pathParts[1] && pathParts[1].length > 0) {
      return true;
    }
  }
  return false;
};

class Routes extends React.Component {
  constructor() {
    super();
    this.state = {
      myRoutes: [],
      isDateUpdate: null,
      popupNode: null,
      jMode: config.enumGameMode.live,
    };

    let eventValidators = app.eventValidators;
    let eventValidatorsGameLocked = app.eventValidatorsGameLocked;
    let eventValidatorsGameplayLocked = app.eventValidatorsGameplayLocked;
    // let eventValidatorsLoggedIn = app.eventValidatorsLoggedIn;

    this.routes = [...arrMenu];

    //login menu add kiya hai
    for (let jN = 0; jN < (this.routes || []).length; jN++) {
      let row = this.routes[jN];
      // row.validator = eventValidators;
      row = { ...row, validator: eventValidators };
      // if (row.isAuthorize === 1) {
      //     row.validator = eventValidatorsLoggedIn;
      // }
      if (row.isEndOfTour === 1) {
        // row.validator = eventValidatorsGameLocked;
        row = { ...row, validator: eventValidatorsGameLocked };
      }
      if (row.isEndOfTour === 2) {
        // row.validator = eventValidatorsGameplayLocked;
        row = { ...row, validator: eventValidatorsGameplayLocked };
      }
      this.routes[jN] = {
        ...row,
        path: row.link ? row.link.toLowerCase() : "",
        component: ObjRoute[row.link ? row.link.toLowerCase() : ""],
        validator: row.validator,
      };
    }
  }

  render() {
    const self = this;
    const { nodeLoader } = self.props;
    let myRoutes = self.routes.map((el, index) => {
      let component = el.component;
      let sPath = el.path;
      let propsRoute = {
        DefaultComponent: component,
        sPath: sPath,
        routeObject: el,
        ...self.props,
      };
      //console.log((config.URL_BASE + el.path))
      return (
        <Route
          key={el.id}
          path={config.URL_BASE + el.path}
          render={(props) => {
            return doDefaultNavigation({ ...props, ...propsRoute });
          }}
        />
      );
    });

    return (
      <BrowserRouter>
        <Suspense fallback={nodeLoader}>
          <Switch>
            <Route
              path={`${config.URL_BASE}more/tnc`}
              render={(props) => {
                return <TermsNCondition {...props} />;
              }}
            />
            <Route
              path={`${config.URL_BASE}more/privacy_policy`}
              render={(props) => {
                return <PrivacyPolicy {...props} />;
              }}
            />
            <Route
              path={`${config.URL_BASE}boosters-history`}
              render={(props) => {
                return <UserBoostersHistory {...props} />;
              }}
            />
            {myRoutes}
            <Route component={NoMatch} />
          </Switch>
          {/* <GDPR /> */}
        </Suspense>
      </BrowserRouter>
    );
  }
}

export default Routes;
